// src/layouts/DashboardLayout.jsx

import FloatingNav from "../components/FloatingNav";
import FooterNav from "../components/FooterNav";
import MobileNavbar from "../components/MobileNavbar";
import Sidebar from "../components/Sidebar";

import { useState } from "react";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 p-4 pt-16 pb-20 md:pt-4 md:pb-4 h-screen overflow-y-auto">
        {children}
  <FooterNav /> 
     <FloatingNav/>
      </div>
    </div>
  );
};

export default Layout;
